import { RouteObject } from "react-router-dom"
import ChangePassword from "pages/change-password"
import AiChatbot from "pages/ai-chat-bot"
import NotFoundPage from "pages/not-found-page"
// import UserDashboard from "../pages/user-dashboard"
import Logger from "pages/logger"
import Home from "pages/home"
import PdfUpload from "pages/pdf-upload"
import AddUpdateLoginPDF from "pages/pdf-upload/AddUpdateLoginPDF"
import VoiceUpload from "pages/voice-upload/voiceHistorySftp"
import Forecast from "pages/forecast"
import Replenish from "components/replenish/Replenish"
import SalesForecast from "pages/sales-forecast/index"
import SentimentAnalysis from "pages/generate-sentiment-analysis"
import DynamicPricing from "pages/dynamic-pricing"
import ButterPie from "pages/butter-pie"



let routes: RouteObject[] = [
	// {
	// 	path: "/logger",
	// 	element: <Logger />,
	// },
	{
		path: "/change-password",
		element: <ChangePassword />,
	},
	{
		path: "/creator-mate",
		element: <ButterPie />,
	},
	{
		path: "/forecast",
		element: <Forecast />,
	},
	{
		path: "/replenish",
		element: <Replenish />,
	}, {
		path: "/salesforecast",
		element: <SalesForecast />
	}, {
		path: "/dynamic-pricing",
		element: <DynamicPricing />
	},
	{
		path: "/voice-upload",
		children: [
			{
				index: true,
				element: <PdfUpload />,
			}, {
				path: ':id',
				element: <AddUpdateLoginPDF />
			},
			{
				path: "/voice-upload/file-config",
				element: <VoiceUpload />,
			},
		]
	},

	{
		path: "/",
		children: [
			{
				index: true,
				element: <AiChatbot />,
			},
		],
	},
	{
		path: "*",
		element: <NotFoundPage />,
	},
]

export default routes

